import React from "react";
import { Linkedin, Instagram } from "lucide-react";

export const WHATSAPP_NUMBER_E164 = "447881521243";
export const WHATSAPP_DISPLAY = "+44 7881 521 243";
export const LINKEDIN_URL = "https://www.linkedin.com/company/calmbreeze-hvac/";
export const NEXTDOOR_URL = "https://nextdoor.co.uk/page/calm-breeze-west-drayton-gb-eng-1";
export const GOOGLE_BUSINESS_URL = "https://share.google/inPUutMi8EIQEVDtq";
export const GOOGLE_REVIEW_URL = "https://g.page/r/CZDmEm-YtsD-EBI/review";
export const INSTAGRAM_URL = "https://www.instagram.com/calmbreeze.hvac";
export const BARK_URL = "https://www.bark.com/en/gb/b/calmbreeze/2MmeEg/";
export const MYJOBQUOTE_URL = "https://www.myjobquote.co.uk/t/calmbreeze-1";

const WhatsappIcon = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
    <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/>
  </svg>
);

const NextdoorIcon = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
    <path d="M12 2.2 1.8 10.4c-.5.4-.6 1.1-.2 1.6.4.5 1.1.6 1.6.2L4 11.6V20c0 1.1.9 2 2 2h3.2c.4 0 .8-.4.8-.8v-4.7c0-.6.5-1 1-1h2c.6 0 1 .4 1 1v4.7c0 .4.4.8.8.8H18c1.1 0 2-.9 2-2v-8.4l.8.6c.5.4 1.2.3 1.6-.2.4-.5.3-1.2-.2-1.6L12 2.2z"/>
  </svg>
);

const GoogleIcon = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
  </svg>
);

const BarkIcon = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm3.5 7.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zm-7 0c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5S7 11.83 7 11s.67-1.5 1.5-1.5zM12 18c-2.28 0-4.22-1.66-5-4h10c-.78 2.34-2.72 4-5 4z"/>
  </svg>
);

const MyJobQuoteIcon = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
    <path d="M4 3h16a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-7l-5 4v-4H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zm6.3 11.2 6.4-6.4-1.4-1.4-5 5-2.3-2.3-1.4 1.4 3.7 3.7z"/>
  </svg>
);

export const SOCIAL_LINKS = [
  { id: "google", label: "See us on Google", href: GOOGLE_BUSINESS_URL, Icon: GoogleIcon },
  { id: "linkedin", label: "LinkedIn", href: LINKEDIN_URL, Icon: Linkedin },
  { id: "instagram", label: "Instagram", href: INSTAGRAM_URL, Icon: Instagram },
  { id: "whatsapp", label: "WhatsApp", href: `https://wa.me/${WHATSAPP_NUMBER_E164}`, Icon: WhatsappIcon },
  { id: "nextdoor", label: "Nextdoor", href: NEXTDOOR_URL, Icon: NextdoorIcon },
  { id: "bark", label: "See us on Bark", href: BARK_URL, Icon: BarkIcon },
  { id: "myjobquote", label: "See us on MyJobQuote", href: MYJOBQUOTE_URL, Icon: MyJobQuoteIcon },
];

export const SocialLinks = ({ tone = "ink", size = "sm", gap = "gap-2", testIdPrefix = "social" }) => {
  const sizing = size === "lg" ? "h-10 w-10" : "h-8 w-8";
  const iconSize = size === "lg" ? "h-4 w-4" : "h-3.5 w-3.5";
  const baseTone = {
    ink: "border-black/10 text-ink/70 hover:text-ink hover:border-ink/40",
    inverse: "border-white/15 text-white/70 hover:text-white hover:border-white",
    accent: "border-accent/40 text-accent hover:text-white hover:bg-accent",
  }[tone] || "border-black/10";

  return (
    <div className={`flex items-center ${gap}`} data-testid={`${testIdPrefix}-group`}>
      {SOCIAL_LINKS.map(({ id, label, href, Icon }) => (
        <a
          key={id}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          data-testid={`${testIdPrefix}-${id}`}
          className={`inline-flex items-center justify-center ${sizing} rounded-full border ${baseTone} transition-all duration-300`}
        >
          <Icon className={iconSize} />
        </a>
      ))}
    </div>
  );
};

export const ReviewsStrip = ({ tone = "ink", testId = "reviews-strip" }) => {
  const muted = tone === "inverse" ? "text-white/60" : "text-muted-foreground";
  const link = tone === "inverse" ? "text-white hover:text-accent" : "text-ink hover:text-brand";
  const sites = [["Google", GOOGLE_BUSINESS_URL], ["Bark", BARK_URL], ["MyJobQuote", MYJOBQUOTE_URL]];
  return (
    <p className={`text-[12px] ${muted}`} data-testid={testId}>
      Read our reviews on{" "}
      {sites.map(([name, href], i) => (
        <React.Fragment key={name}>
          {i > 0 && " · "}
          <a href={href} target="_blank" rel="noopener noreferrer" className={`font-semibold underline-offset-2 hover:underline ${link}`} data-testid={`${testId}-${name.toLowerCase()}`}>{name}</a>
        </React.Fragment>
      ))}
    </p>
  );
};

export default SocialLinks;
